import { z } from '@/libs';

export const countSchema = z.object({
  count: z.coerce
    .number()
    .min(1, 'A quantidade mínima é 1.')
    .max(999_999, 'A quantidade máxima é 999999.'),
});

export type CountSchemaType = z.infer<typeof countSchema>;
